import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsSplashScreenComponent } from "./ds-splash-screen.component";
import { DsLoaderModule } from "../ds-loader/ds-loader.module";

@NgModule({
  declarations: [DsSplashScreenComponent],
  imports: [CommonModule, DsLoaderModule],
  exports: [DsSplashScreenComponent],
})
export class DsSplashScreenModule {}
